<template>
  <div class="item justify-between align-center">
    <div class="flex">
      <div class="flex mr-16">
        <img v-lazy="music.picsrc" class="img" :class="{ 'single': music.album_type === 'single' }">
        <img v-show="music.album_type !== 'single'" v-lazy="'http://sanka-static.oss-cn-beijing.aliyuncs.com/h5/bg/bg-album.png'" class="bg-img">
      </div>
      <div class="flex align-center flex-1">
        <div>
          <h3 class="flex fs-14">
            <van-tag color="#0D0E15" round class="mr-6">{{ music.album_type === 'single' ? '单曲' : '专辑' }}</van-tag>
            <span class="van-ellipsis">{{ music.album_type === 'single' ? music.music_name : music.album_name }}</span>
          </h3>
          <p class="flex mt-8 align-center fs-12 color-9DA4B3">
            <span class="mr-6">{{ music.createtime * 1000 | formatTime }}&nbsp;创建</span>
            <span class="flex"><van-tag :color="tagTypes[music.status]" round>{{ musicStatus[music.status + String(music.sp_online)] }}</van-tag></span>
          </p>
        </div>
        <van-button v-if="+music.sp_share === 1 && +music.status === 99" color="#fc3159" size="small" round class="van-btn" @click.stop="share"> <i class="iconfont icon-share1"></i> 分享</van-button>
        <van-button v-else-if="[0, 1, 10, 40].includes(music.status)" :color="tagTypes[music.status]" size="small" round class="van-btn" @click.stop="$toast('请使用电脑登录网站平台进行操作')">{{ btnTxt[music.status] }}</van-button>
      </div>
    </div>

    <!-- <mr-share ref="MrShare" :music="music"></mr-share> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    music: {
      type: Object
    }
  },
  computed: {
    materialList() {
      const { media_count } = this.music
      if (!media_count) return []
      const list = Object.entries(media_count).filter(val => val[1] > 0).map(val => val[0])
      return this.mediaArr.map(val => ({
        ...val,
        active: list.includes(val.key) ? 1 : 0
      }))
    },
    progressMusic() { // 作品物料百分比
      const totalCount = this.mediaArr.length // 物料总个数
      const count = this.materialList.filter(val => val.active > 0).length // 物料点亮的个数
      return count === 0 ? 0 : Math.round((100 / totalCount) * count)
    },
    btnTxt() {
      return {
        0: '去完善',
        1: '选渠道',
        10: '去签署',
        40: '去修改'
      }
    },
    ...mapState(['musicStatus', 'tagTypes', 'mediaArr'])
  },
  methods: {
    share() {
      this.$emit('share', this.music)
      // this.$refs.MrShare.share({ album_type: this.music.album_type })
    }
  }
}
</script>

<style lang="scss" scoped>
.item{
  padding: 15px 13px;
}
.img{
  width: 55px;
  height: 55px;
  &.single{
    border-radius: 50%;
    margin-right: 5px;
  }
}
.bg-img{
  width: 5px;
  height: 55px;
}
.van-btn{
  display: block;
  width: 65px;
  height: 26px;
  line-height: 26px;
  white-space: nowrap;
}
.van-ellipsis{
  width: 164px;
}
</style>
